import {SVGProps} from 'react';

const Icon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        fill="none"
        height="16"
        viewBox="0 0 16 16"
        width="16"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M3.5 14.2046V2.5C3.5 1.94772 3.94772 1.5 4.5 1.5H11.5C12.0523 1.5 12.5 1.94772 12.5 2.5V14.2046C12.5 14.3461 12.3571 14.4428 12.2257 14.3903L10.0834 13.5334C10.0303 13.5121 9.97077 13.5146 9.91967 13.5402L8.08944 14.4553C8.03314 14.4834 7.96686 14.4834 7.91056 14.4553L6.08033 13.5402C6.02923 13.5146 5.96965 13.5121 5.91661 13.5334L3.77428 14.3903C3.64291 14.4428 3.5 14.3461 3.5 14.2046Z"
            fill="#F9F9F9"
            stroke="#3C3C3C"
        />
        <circle cx="7" cy="5" fill="#C2C2C2" r="1.5" stroke="#3C3C3C" />
        <path d="M5.5 8.5H6.5" stroke="#3C3C3C" strokeLinecap="round" />
        <path d="M8.5 8.5H10.5" stroke="#3C3C3C" strokeLinecap="round" />
        <path d="M5.5 10.5H10.5" stroke="#3C3C3C" strokeLinecap="round" />
    </svg>
);

export default Icon;
